import React from "react";
import FieldMultiSelect from "../../shared/controls/fieldMultiSelect";
import FieldDropDown from "../../shared/controls/fieldDropDown";

const FiltroTarifaPermisionarios = ({ filtro, onChange }) => {
    console.log(filtro)
  return (
    <>
      <FieldMultiSelect
        name="permisionarioId"
        label="Permisionarios"
        source="permisionarios"
        showClear={true}
        colMd={2}
        colLg={2}
        value={filtro.permisionarioId}
        onChange={onChange}
        valueAsId={true}
      />

      <FieldDropDown
        name="estadoOrigenId"
        source="estados"
        label="Estado Origen"
        colMd={2}
        filter={true}
        required={true}
        value={filtro.estadoOrigenId?.id}
        onChange={onChange}
      />

      <FieldDropDown
        name="municipioOrigenId"
         source={
            filtro.estadoOrigenId
            ? `municipiosEstados/${filtro.estadoOrigenId.nombre}`
            : "municipiosEstados/0"
        }
        label="Municipio Origen"
        params={{ estadoId: filtro.estadoOrigenId?.nombre }}
        colMd={2}
        filter={true}
        required={true}
        value={filtro.municipioOrigenId}
        onChange={onChange}
        
      />
      <FieldDropDown
        name="estadoDestinoId"
        source="estados"
        label="Estado Destino"
        colMd={2}
        filter={true}
        required={true}
        value={filtro.estadoDestinoId?.id}
        onChange={onChange}
      />

      <FieldDropDown
        name="municipioDestinoId"
         source={
            filtro.estadoDestinoId
            ? `municipiosEstados/${filtro.estadoDestinoId.nombre}`
            : "municipiosEstados/0"
        }
        label="Municipio Destino"
        params={{ estadoId: filtro.estadoDestinoId?.nombre }}
        colMd={2}
        filter={true}
        required={true}
        value={filtro.municipioDestinoId}
        onChange={onChange}
        disabled={!filtro.estadoDestinoId}
      />


      <FieldMultiSelect
        name="tipoUnidadId"
        label="Tipo unidad"
        source="tiposUnidad"
        showClear={true}
        colMd={1}
        colLg={1}
        value={filtro.tipoUnidadId}
        onChange={onChange}
        valueAsId={true}
      />
    </>
  );
};

export default FiltroTarifaPermisionarios;
